const V = {
  name: "Plugins",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 2V5H18V2H20V5H22V10C22 12.4198 20.2828 14.437 18 14.9001V17C18 19.7623 15.7623 22 13 22C10.2377 22 8 19.7623 8 17V11.5C8 10.6723 7.32771 10 6.5 10C5.67228 10 5 10.6723 5 11.5V17H3V11.5C3 9.56772 4.56772 8 6.5 8C8.43228 8 10 9.56772 10 11.5V17C10 18.6577 11.3423 20 13 20C14.6577 20 16 18.6577 16 17V14.9001C13.7172 14.437 12 12.4198 12 10V5H14V2H16ZM20 7H14V10C14 11.6577 15.3423 13 17 13C18.6577 13 20 11.6577 20 10V7Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as Plugins
};
